module.exports = global.EventSource;



//////////////////
// WEBPACK FOOTER
// (webpack)-dev-server/~/sockjs-client/lib/transport/browser/eventsource.js
// module id = 44
// module chunks = 0